const proDrop = [
  {
    id: 0,
    title: "Government Sector",
    purl: "bro",
  },
  {
    id: 1,
    title: "Educational Institutions",
    purl: "shemfordschool",
  },
  {
    id: 2,
    title: "Corporate",
    purl: "hdfc",
  },
  // {
  // 	id: 3,
  // 	title: "Health",
  // 	purl: "dhenkanal",
  // },
  {
    id: 4,
    title: "Hospitality",
    purl: "sukhdeoclarksinn",
  },
  // {
  // 	id: 5,
  // 	title:"Religion and Culture",
  // 	purl:"religionandculture",
  // },
  {
    id: 6,
    title: "Retail",
    purl: "karmatemple",
  },
  {
    id: 7,
    title: "Telecommunications",
    purl: "usof",
  },
  {
    id: 7,
    title: "Health",
    purl: "siliguri",
  },
];

export { proDrop };



// WEBPACK FOOTER //
// ./src/constant/projectDrop.js